module.exports = require("core-js/modules/web.dom-collections.for-each");